/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Paste_Into_CurrentInputs */



/**
* | output |
* | --- |
* | "Paste into Current" |
*
* @param {Spaces_Paste_Into_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_paste_into_current = /** @type {((inputs?: Spaces_Paste_Into_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Paste_Into_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("In aktuellen Ordner einfügen")
	return /** @type {LocalizedString} */ ("Paste into Current")
});